<template>

    <b-row class="w-100 d-flex justify-content-center align-items-center" style="padding-top: 10px; height:80%;">
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        <loading :active="loading"
             :is-full-page="false"/>

        <div v-if="isFlexible && tableData" class="d-flex align-items-center justify-content-center flex-column" style="flex:1">
            <ChartTable :tableData="tableData"/>
        </div>

        <apexchart v-if="series && !thereIsNoData" id="chart" style="flex:3;"
        width="100%" height="90%" ref="apexchart" 
        :options="chartOptions" 
            :series="series" />
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ChartTable from "./ChartTable.vue";
import {generateLabelDateArray, getProjectPeriodByHistory, getHistoryGroupByStatus} from '@/components/chatter/util/graphUtils';
export default {
    name: 'ProjectOutputGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts,
        ChartTable
    },
    mounted() {
        this.historyData = getHistoryGroupByStatus(this.dashboardData.history);

        if(this.historyData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.startDate = this.dashboardData.projectInfo.startDate;
            this.endDate = this.dashboardData.projectInfo.endDate;

            // 시작, 종료 날짜 둘중 하나라도 비어있으면 히스토리에서 시작, 종료 가져옴
            if(this.startDate == '' || this.endDate == '') {
                const [historyStart, historyEnd] = getProjectPeriodByHistory(this.historyData);

                this.startDate = historyStart;
                this.endDate = historyEnd;
            }
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                console.log("modify filter reload");
                
                this.series = [];
                this.chartOptions.xaxis.categories = [];
                this.reloadGraph();
            }
        },
    },
    data() {
        return {
            thereIsNoData: false,
            startDate : '',
            endDate: '',
            historyData: '',
            loading:false,
            columnNames: [],
            series: [],
            interval: 7,
            dateRange : [],
            tableData: '',
            chartOptions: {
                chart: {
                    height:'90%',
                    type: "area",
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                markers: {
                    size: false
                },
                dataLabels: {
                    enabled: this.isFlexible, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                    style: {
                        fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                        colors: ['#333'], // 데이터 라벨의 색상을 지정합니다.
                    },
                    // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                    offsetY: -9, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                    formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                        return val;
                    },
                    background: { // 데이터 라벨의 배경을 설정합니다.
                        enabled: true,
                        foreColor: '#fff',
                        padding: 4,
                        borderRadius: 4,
                        borderWidth: 1,
                        borderColor: '#ccc',
                        opacity: 0.8,
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                stroke: {
                    width: [4, 4, 4, 4],
                    curve: 'smooth',
                },
                xaxis: {
                    categories: [],
                    show:this.isFlexible,
                    labels: {
                        show:this.isFlexible
                    }
                },
                yaxis: {
                    labels: {
                        show:this.isFlexible
                    }
                },
                legend: {
                    show: true,
                    showForSingleSeries: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: -15,
                    fontSize:'8px'
                },
                grid : {
                    show:false
                }
            },
        }
    },
    methods: {
        getLabelDateArray() {

            let from = this.startDate;
            let to = this.endDate;

            //여기서 eow를 사용하지 않아서 null 처리
            //graphUtils 에서 null로 받으면 프로젝트 첫 시작을로 처리하는 로직 있음
            let eow = null;
            let interval = 7;
            
            if(this.isFlexible) {
                if(this.filters.from != '') {
                    from = this.filters.from;
                }

                if(this.filters.to != '') {
                    to = this.filters.to;
                }

                if(this.filters.interval != '') {
                    interval = this.filters.interval;
                }

                if(this.filters.eow != '') {
                    eow = this.filters.eow;
                }
            }

            let labelDateArray = generateLabelDateArray(from, to, null, interval);

            return labelDateArray;
        },

        countData(labelDateArray, dataArray) {

            const arraySize = labelDateArray.length;

            let grandTotalCount = 0;

            let countObj = [
                {
                    name : '생산량',
                    type : 'area',
                    data : new Array(arraySize).fill(0)
                },
            ]

            let index = 0;
            let interval = 7;
            if(this.isFlexible) {
                interval = this.filters.interval != '' ? this.filters.interval : interval;
            }
            interval = Number(interval);
            for(let labelDate of labelDateArray) {

                let startDate = new Date(labelDate);
                let endDate = new Date(startDate);

                endDate.setDate(endDate.getDate() + interval);

                dataArray.forEach(item=> {
                    let actualDate = new Date(item.maxUpdatedDate);

                    if(item.status == 'DONE' && (startDate <= actualDate && actualDate < endDate)) {        
                        countObj[0]['data'][index]++;
                        grandTotalCount++;
                    }                  
                });
                index++;
            }

            this.tableData = {                 
                "Index": [
                    "Total",
                ],
                "Count": [grandTotalCount],
            }

            return countObj;
        },

        visualizeGraph() {
            let dataArray = this.historyData;

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;

                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                dataArray = dataArray.filter(item => {
                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) && 
                        BUSINESS_CATEGORY.includes(item.businessCategory) 
                    );
                });
            }

            let labelDateArray = this.getLabelDateArray();

            let countObj = this.countData(labelDateArray, dataArray);
        
            this.series = countObj;
            this.label = labelDateArray;

            this.setLabels();
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            this.chartOptions.xaxis.categories = this.label;

            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions({
                    xaxis: {
                        categories: this.label,
                    },
                });
            }
        },
        setTable() {
            this.tableData = this.data.table;

        }
    },
}
</script>
